export const chaveArmazenamentoUsuario = 'usuario-aplicacao-prova';

export const permissaoApp = 'germina-aplicacao-prova';

export const pageRoutes = {
  Login: '/',
  TestList: '/testList',
  TestManual: '/testManual',
  TestRoom: '/testRoom',
  AccuracyRate: '/accuracyRate',
};

export const iconesNotificacao = {
  ErroPadrao: 'ErroPadrao',
  TentarNovamente: 'TentarNovamente',
};

export const mensagensNotificacaoErro = {
  UsuarioSemPermissaoDeAcesso: 'Usuário não possui acesso ao recurso',
  FalhaAoListarProvas: 'Falha ao listar provas',
  FalhaConsultaDados: 'Falha ao consultar dados',
  ErroPadrao: 'Ocorreu um erro ao tentar executar esta ação.',
  FalhaDisponibilidadeProva: 'O tempo para realização da prova acabou.',
};

export const informacoesModais = {
  TextoBotaoCancelar: 'Cancelar',
  ModalSair: {
    Titulo: 'Deseja Sair?',
    TextoBotaoContinuar: 'Sair',
  },
  ModalIniciarProva: {
    Descricao: 'Tem certeza que deseja iniciar a prova da disciplina acima?',
    TextoBotaoIniciar: 'Iniciar Prova',
    TextoBotaoContinuar: 'Continuar Prova',
  },
  ModalFinalizarProvaIncompleta: {
    Titulo: 'Prova em Andamento',
    Descricao:
      'O tempo da prova ainda não acabou e você tem questões que não foram respondidas.',
    TextoBotaoContinuar: 'Entregar Mesmo Assim',
  },
  ModalFinalizarProvaCompleta: {
    Titulo: 'Entregar Prova',
    Descricao:
      'Ao confirmar, sua prova será entregue e você não poderá alterar suas respostas.',
    TextoBotaoContinuar: 'Entregar Prova',
  },
};

export const mensagensListaProvas = {
  provaEncerrada: 'Esta prova não está mais disponível.',
  provaAgendada: 'Esta prova ainda não está disponível.',
};

export const ambiente = {
  producao: { codigo: 'producao' },
  homologacao: { codigo: 'homologacao' },
  rollout: { codigo: 'rollout' },
  desenvolvimento: { codigo: 'desenvolvimento' },
  local: { codigo: 'local' },
  teste: { codigo: 'teste' },
};

export const situacaoProva = {
  Agendada: 'AGENDADA',
  Realizar: 'REALIZAR',
  Entregue: 'ENTREGUE',
  Encerrada: 'ENCERRADA',
  EmAndamento: 'EM ANDAMENTO',
  Corrigida: 'CORRIGIDA'
};

export const testsPerPage = 5;

export const notFoundImageOptions = {
  detectiveCenter: 1,
  magnifyingGlassCenter: 2,
  magnifyingGlassLeft: 3,
  smallMagnifyingGlassCenter: 4,
  detectiveCenterTryAgain: 5,
};

export const manualModal = {
  Title: 'Manual de Prova',
  DisciplineTitle: 'Disciplina',
  QuestionsTitle: 'Questões',
  DurationTitle: 'Duração',
  FinalPeriodTitle: 'Data Final e Horário Final',
  FinalPeriodDescription:
    'Às {TIME} do dia {DATE} será o prazo máximo para submissão de respostas',
  PerformTestButtonTitle: 'Realizar Prova',
  ContinueTestButtonTitle: 'Continuar Prova',
  BackToStartButtonTitle: 'Voltar ao início',
  TermsAndConditionsMessage: 'Li e concordo com os',
  TermsAndConditionsLink: 'termos e condições',
  WarningPerform:
    'Importante: Caso o aluno inicie a prova próximo ao horário de encerramento, mesmo se ainda houver tempo de duração restante, a prova será submetida às {TIME} do dia {DATE}',
  WarningContinue:
    'Lembrando que se o aluno iniciar a prova às {TIME} terá apenas {DURATION} para submeter as respostas e então a prova será encerrada',
  PdfUrl: 'https://cdn.germina.com.vc/Regulamento%20Simulado%20EnadeFMU.pdf',
};

export const mensagemClipBoardPrintScreen = 'Error 404 - Not found';
